/* eslint-disable no-param-reassign */
/* global spaParams */

/*
 * secure-link-utility
 * Utility that transmogrifies secure production links into your current top domain links instead
 *
 * Copyright (c) 2017 Bank of America
 * Author: Brandon Minton
 */
const checkifValid = path => {
  const hasHttp = path.match('http') && path.match('http').index === 0;
  const hasSlash = path.match('/') && path.match('/').index === 0;
  const isLocal = path.match('localhost') && path.match('localhost').index === 0;
  return hasHttp || hasSlash || isLocal;
};
const getAddress = (newRoot, path) => {
  if (checkifValid(path)) {
    return `${newRoot}${path.replace(/^.*\/\/[^/]+/, '')}`;
  }
  return false;
};
console.log('####################### secure-link-utility loaded ##################');

/**
 * @class SecureLinkUtility
 */
class SecureLinkUtility {
  /**
   * @param {string} newRoot the string we are looking to replace
   * @param {array} anchorsToUpdate the links in which you'll update
   * @returns {void}
   */
  iterateLinks(newRoot = 'https://secure.bankofamerica.com', anchorsToUpdate = document.querySelectorAll('a')) {
    [...anchorsToUpdate].forEach(anchorNode => {
      const newHref = getAddress(newRoot, anchorNode.pathname);
      if (newHref) anchorNode.href = newHref + anchorNode.search + anchorNode.hash;
    });
  }

  /**
   * @param {node} container: whatever the parent element is that you'll search through -
   * container needs to be a javascript node, not jQuery
   * @param {string} queryString: any class you'll be looking for within the parent container
   * @returns {array} that contains the elements that contain links you'll be replacing
   */
  collectLinks(container, queryString = 'a') {
    return [...container.querySelectorAll(`${queryString}[href]`)].map(anchor => anchor);
  }

  /**
   * Replace all not prod secure absolute links with correct secure environment links
   * To replace links on all pages, include secure-link-utility in the
   * site's config file and execute SecureLinkUtility.default.run()"
   * Example:
   *  "requireConfig": {
      "utilities": {
        "community/secure-link-utility": "^4.0.0",
        "global/sparta-bootstrap-utility": "^x.y.z"
      },
      "exec": [
        "SecureLinkUtility.default.run()",
        "spartaBootstrapUtility.default.init(arguments);"
      ]
    }
   * @returns {void}
   */
  run() {
    if (!spaParams.siteParams.env.match(/prod/)) {
      const anchorsToUpdate = this.collectLinks(document.querySelector('body'), '[href*="https://secure.bankofamerica.com/"]');
      this.iterateLinks(spaParams.siteParams.secureHost, anchorsToUpdate);
    }
  }
}
var index = new SecureLinkUtility();

export { index as default };
